/**
 * Merchant legal fields: Chargex (no countries in runtime) keeps INN/BIC/VAT.
 * International uses GET /runtime merchantFields for the merchant's country.
 */

export const LEGACY_MERCHANT_FIELDS = [
  'givenName',
  'familyName',
  'middleName',
  'phone',
  'accountNumber',
  'bankName',
  'bic',
  'inn',
  'legalName',
  'address',
];

/** Shared legal fields when country is unknown — never INN / BIC / VAT. */
export const COMMON_INTERNATIONAL_FIELDS = [
  'legalName',
  'address',
  'email',
  'phone',
  'givenName',
  'familyName',
];

export function isInternationalRuntime(runtime) {
  if (!runtime) return false;
  if (runtime.runtime === 'international') return true;
  return Array.isArray(runtime.countries) && runtime.countries.length > 0;
}

function countryById(countries, id) {
  if (!id) return null;
  const key = String(id).trim().toUpperCase();
  return (countries || []).find((c) => String(c.id || '').toUpperCase() === key) || null;
}

/** Guess UA/ID from tax ids and phone until country lives on the partner. */
export function resolveMerchantCountry(info, countries = []) {
  if (!countries.length) return null;
  const explicit = info?.countryId ?? info?.country ?? info?.location;
  const fromId = countryById(countries, explicit);
  if (fromId) return fromId;
  if (String(info?.npwp || '').trim()) return countryById(countries, 'ID');
  if (String(info?.edrpou || '').trim() || String(info?.iban || '').trim()) {
    return countryById(countries, 'UA');
  }
  const phone = String(info?.phoneNumber || '').replace(/\D/g, '');
  const byPrefix = countries.find(
    (c) => c.phonePrefix && phone.startsWith(String(c.phonePrefix)),
  );
  return byPrefix || null;
}

export function merchantFieldsFor(runtime, info) {
  if (runtime == null) {
    return [];
  }
  if (!isInternationalRuntime(runtime)) {
    return null;
  }
  const country = resolveMerchantCountry(info, runtime.countries);
  if (Array.isArray(country?.merchantFields) && country.merchantFields.length) {
    return country.merchantFields;
  }
  return COMMON_INTERNATIONAL_FIELDS;
}

/**
 * @param {string[]|null} fields  null = Chargex legacy set
 */
export function showMerchantField(fields, field) {
  if (fields == null) {
    return LEGACY_MERCHANT_FIELDS.includes(field) || field === 'withNDS';
  }
  return fields.includes(field);
}
